import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { decryptData } from "../../../utils/encrypt";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import { callautopopulate } from "../../../services/callautopop";
import { DateObject } from "react-multi-date-picker";
import { calculateWordsFromString, dateConvert, dateHoverRange, getFullMonthSelected } from "../../../utils/Helper";

export const useCalender = () => {
    const tagRef = useRef(null);
    const [userCode] = useState(decryptData(sessionStorage.getItem("user_code")));
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [showTimesheet, setShowTimesheet] = useState(false);
    const [logDetails, setLogDetails] = useState({});
    const [tableData, setTableData] = useState({ log_details: [], log_time: [] });
    const [showAddLog, setShowAddLog] = useState(false);
    const { selectedEmployee } = useEmployeFilter();
    const [approvePopup, setApprovePopup] = useState(false);
    const [approvalData, setApprovalData] = useState({});
    const [popupDate, setPopupDate] = useState(new Date());
    const [popupLogDetails, setPopupLogDetails] = useState({});
    const [approveTimePopup, setApproveTimePopup] = useState(false);
    const [options, setOptions] = useState({});
    const [approvalLoader, setApprovalLoader] = useState(false);
    const [loader, setLoader] = useState(true);
    const [calendarDate, setCalendarDate] = useState(new Date());
    const [pendingLogDate, setPendingLogDate] = useState([]);
    const [logLoader, setLogLoader] = useState(false);
    const [logHours, setLogHours] = useState({})
    const [isWorklog, setIsWorklog] = useState(true);
    const [callAttendanceApi, setCallAttendanceApi] = useState(false);
    const [extensionForm, setExtensionForm] = useState({ reason: '', apply_enable_datetime: null });
    const [enabelPopup, setEnabelpopup] = useState(false)
    const legendMenuRef = useRef(null);
    const legendItems = [
        { color: "#fff280ff", type: "background", title: "Logs Pending" },
        { color: "#4680ff", type: "background", title: "Pending to Send for Approval" },
        { color: "#ff9800", type: "background", title: "Sent for Approval" },
        { color: "#8df1a9", type: "background", title: "Approved" },
        { color: "#ff7d7d", type: "background", title: "Rejected" },
        { color: "#9e12ee", type: "border", title: "Leave" },
        { color: "#ffdee3", type: "background", title: "Holiday" },
        { color: "#d5d5d5", type: "background", title: "Weekly off" },
        { color: "#c7d9f3", type: "background", title: "Optional Holiday" },
    ];
    const legendMenuItems = [
        {
            key: "legend_menu_item",
            template: () => (
                <div>
                    <div className="ps-3 fw-bold">Legend</div>
                    {legendItems.map((item) => (
                        <div div className="d-flex align-items-center gap-2 py-1 ps-2" key={item?.title || ""}>
                            <div style={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: item.type === "background" ? item.color : "transparent", border: item.type === "border" ? `3px solid ${item.color}` : "none" }} />
                            <span>{item.title}</span>
                        </div>
                    ))}
                </div >
            )
        }
    ]

    const [filterValue, setFilterValue] = useState({
        hoveredRange: [new DateObject(), new DateObject()],
        isChange: false,
    });

    useEffect(() => {
        callautopopulate("users", "request_approver_leads").then(async res => {
            const users = res?.users?.map((user) => ({
                label: user.user_display_name,
                value: user.user_code,
            })).sort((a, b) => a.label?.localeCompare(b.label));
            setOptions({ users, approverList: res?.request_approver_leads });

        })
    }, [])

    useEffect(() => {
        getTimesheetCalendarSummary()
    }, [selectedEmployee, calendarDate])

    // eslint-disable-next-line
    const getTimesheetCalendarSummary = async (key, selectedPopupDate) => {
        try {
            if (!selectedEmployee?.user_code) {
                return;
            };
            let obj = {};
            const payload = {
                from_date: dateConvert(getFullMonthSelected((key === "popup" ? (selectedPopupDate || popupDate) : calendarDate) || new Date())?.from_date, "iso-string") || "",
                to_date: dateConvert(getFullMonthSelected((key === "popup" ? (selectedPopupDate || popupDate) : calendarDate) || new Date())?.to_date, "iso-string") || "",
                requested_user_code: selectedEmployee?.user_code || 0
            };
            const res = await services.getInvokeRemote("POST", Urls("GETMYTIMESHEETCALENDERSUMMARY"), payload);
            const timesheetDetails = res.body?.data?.mytimesheet_calendar_summary;
            if (timesheetDetails) {
                let dates = _.uniq(_.pluck(timesheetDetails, "startdate"));
                dates?.forEach((date) => {
                    const data = _.where(timesheetDetails, { startdate: date });
                    const logHours = data?.reduce((sum, r) => sum + parseFloat(r.logged_work_hours || 0), 0);
                    const rejectRemarks = _.filter(data, (record) => record.reject_remark)
                        ?.map(record => record.reject_remark)
                        ?.filter(Boolean)
                        .join('\n');
                    const hasRejectRemark = _.some(data, (record) => record.is_reject);
                    const hasAllApprove = _.every(data, (record) => record.is_approve);
                    let color;
                    if (hasRejectRemark) {
                        color = _.find(data, (record) => record.is_reject)?.log_type_color;
                    } else if (hasAllApprove) {
                        color = _.find(data, (record) => record.is_approve)?.log_type_color;
                    } else {
                        color = _.find(data, (record) => !record.is_approve)?.log_type_color;
                    }
                    const unapprovedRecords = _.filter(data, (record) => !record.is_approve);
                    let dataObj = {};
                    if (_.isEmpty(_.findWhere(obj, { startdate: date }))) {
                        dataObj["startdate"] = date;
                        dataObj["holiday"] = data?.[0]?.is_active_holiday;
                        dataObj["loginfo"] = logHours;
                        dataObj["leave"] = data?.[0]?.is_active_leave === 1 ? true : false;
                        dataObj["leave_type_key"] = data?.[0]?.leave_type_key;
                        dataObj["day_working_hours"] = data?.[0]?.day_working_hours
                        dataObj["log_type_color"] = color;
                        dataObj["sent_worklog_ids"] = _.pluck(data, "is_sent_for_worklog_ids").join(',');
                        dataObj["worklog_ids"] = unapprovedRecords?.length > 0 ? _.pluck(unapprovedRecords, "timesheet_worklog_ids").join(',') : null;
                        dataObj["reject_remark"] = rejectRemarks || ""
                        dataObj["is_reject"] = hasRejectRemark
                        obj[date] = dataObj;
                    }
                });
                if (key === "popup") {
                    setPopupLogDetails(obj);
                    await handleFormatData("popup", obj, selectedPopupDate || popupDate);
                    setApprovePopup(true); 
                } else {
                    setLogDetails(obj);
                    handleFormatData("", obj);
                }
                setLoader(false);
            }
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    };

    // this function handle selected date
    // eslint-disable-next-line
    const handleDateSelected = async (val, setLogDate) => {
        try {
            setLogLoader(true)
            setTableData({ log_details: [], log_time: [] });
            let formatDate;
            if (val !== undefined) {
                formatDate = new Date(val)?.toLocaleString("en-GB")?.split(",")[0]?.split("/")?.reverse()?.join("-");
                setFilterValue({ hoveredRange: [new DateObject(val), new DateObject(val)], isChange: false, logworkDate: setLogDate ? new Date(val) : filterValue?.logworkDate });
            }
            const fromDate = formatDate ? formatDate : filterValue?.hoveredRange[0] && dateHoverRange(filterValue?.hoveredRange[0])
            const toDate = formatDate ? formatDate : filterValue?.hoveredRange[1] && dateHoverRange(filterValue?.hoveredRange[1])
            const payload = {
                from_date: fromDate,
                to_date: toDate,
                requested_user_code: selectedEmployee?.user_code || userCode,
                project_ids: val !== undefined ? "" : _.pluck(filterValue?.projects, "project_id")?.toString() || "",
                project_module_ids: val !== undefined ? "" : _.pluck(filterValue?.project_module, "option_id")?.toString(),
                issuetype_ids: val !== undefined ? "" : _.pluck(filterValue?.issueType, "issue_type_id")?.toString(),
            }
            const res = await services.getInvokeRemote("POST", Urls("GETMYTIMESHEETCALENDARDETAILS"), payload);
            if (res?.body?.data?.timesheet_Details || res?.body?.data?.mytimesheet_calendar_details) {
                const data = res?.body?.data?.mytimesheet_calendar_details;
                const logTime = res?.body?.data?.mytimesheet_logtime_details || []
                let dataArr = [];
                data?.forEach((item) => {
                    if (item.issue_id !== null) {
                        dataArr.push(item);
                    }
                })
                setTableData((prev) => ({ ...prev, log_details: dataArr, log_time: logTime }));
                const logSum = data?.filter(log => log?.day_date >= fromDate && log?.day_date <= toDate)
                    .reduce((total, log) => {
                        if (log?.timeSpent === '-' || !log?.timeSpent) return total;
                        const hours = parseFloat(log?.timeSpent);
                        return total + (isNaN(hours) ? 0 : hours);
                    }, 0);
                setLogHours({
                    hours: logSum || 0,
                    date: fromDate === toDate ? dateConvert(fromDate, "day-mon-year") : `${dateConvert(fromDate, "day-mon-year")} to ${dateConvert(toDate, "day-mon-year")}`
                });
                setShowTimesheet(true);
                setFilterValue((prev) => ({ ...prev, isChange: false }))
                setLogLoader(false)
            }
        } catch (error) {
            setLogLoader(false)
            console.error('Error :', error);
        }
    };

    useEffect(() => {
        const filtered = Object.values(logDetails)?.filter(entry => {
            if (/^\d{4}-\d{2}-\d{2}$/.test(entry.startdate)) {
                entry.startdate += "T00:00:00";
            }
            const entryDate = new Date(entry.startdate);
            const actualDate = new Date()
            actualDate.setHours(0, 0, 0, 0);
            entryDate.setHours(0, 0, 0, 0);
            if (entry.holiday) {
                return false;
            }
            return (entryDate <= actualDate || entry?.leave) && parseFloat(entry?.loginfo) < entry?.day_working_hours;
        });
        setPendingLogDate(filtered);
    }, [logDetails])

    // eslint-disable-next-line
    const dateTemplate = (date) => {
        if (date?.otherMonth) {
            return (
                <div></div>
            )
        }
        const currLogDetails = logDetails[`${date.year}-${String(date?.month + 1)?.padStart(2, "0")}-${String(date.day)?.padStart(2, "0")}`];
        const backgroundColor = !currLogDetails?.is_reject && currLogDetails?.loginfo < currLogDetails?.day_working_hours && currLogDetails?.loginfo !== 0 ? "#fff280ff" : currLogDetails?.log_type_color;
        const tooltip = _.findWhere(legendItems, { color: backgroundColor })?.title;
        if (!currLogDetails?.leave) {
            return (
                <div className='wc-date-container'>
                    {currLogDetails?.loginfo > 0 && currLogDetails?.loginfo !== currLogDetails?.day_working_hours &&
                        <div className='wc-logs' style={{ border: `0.5px solid ${currLogDetails?.loginfo < currLogDetails?.day_working_hours && !currLogDetails?.is_reject ? "#f3e13cff" : currLogDetails?.log_type_color}` }}>{currLogDetails?.loginfo}</div>
                    }
                    <div className='wc-dates' style={{ backgroundColor: backgroundColor }} title={tooltip}>
                        <strong>{date.day}</strong>
                    </div>
                </div>
            )
        } else if (currLogDetails?.leave) {
            return (
                <div className='wc-date-container'>
                    {currLogDetails?.loginfo !== currLogDetails?.day_working_hours && <div className='wc-logs' style={{ border: "0.5px solid #9e12ee" }}>{currLogDetails?.loginfo}</div>}
                    <div className='wc-dates' style={{ border: "3px solid #9e12ee", backgroundColor: backgroundColor }} title={tooltip}>
                        <strong>{date.day}</strong>
                    </div>
                </div >
            )
        }

        return date.day;
    };

    const handleFormatData = async (val, dataObj, selectedPopupDate) => {
        let endDate;
        if (val === "popup") {
            endDate = new Date((selectedPopupDate || popupDate)?.getFullYear(), (selectedPopupDate || popupDate)?.getMonth() + 1, 0)?.getDate();
        } else {
            endDate = new Date(calendarDate?.getFullYear(), calendarDate?.getMonth() + 1, 0).getDate();
        }
        const breakAt = 16;
        let obj = { firstHalf: [], secondHalf: [] };
        for (let i = 1; i <= 31; i++) {
            if (i <= breakAt) {
                obj.firstHalf.push({ date: `${String(i)?.padStart(2, "0")}-${String(val === "popup" ? ((selectedPopupDate || popupDate)?.getMonth() + 1) : (calendarDate?.getMonth + 1))?.padStart(2, "0")}-${val === "popup" ? (selectedPopupDate || popupDate)?.getFullYear() : calendarDate?.getFullYear()}` })
            } else {
                if (i <= endDate) {
                    obj.secondHalf.push({ date: `${String(i)?.padStart(2, "0")}-${String(val === "popup" ? ((selectedPopupDate || popupDate)?.getMonth() + 1) : (calendarDate?.getMonth + 1))?.padStart(2, "0")}-${val === "popup" ? (selectedPopupDate || popupDate)?.getFullYear() : calendarDate?.getFullYear()}` })
                } else {
                    obj.secondHalf.push({ date: "" })
                }
            }
        }
        Object.keys(obj)?.forEach((key) => {
            obj?.[key]?.map((item) => {
                const findData = dataObj[item?.date?.split("-")?.reverse()?.join("-")];
                const sentIds = findData?.sent_worklog_ids ? findData?.sent_worklog_ids.split(",")?.map(Number) : [];
                const worklogIds = findData?.worklog_ids ? findData?.worklog_ids.split(",")?.map(Number) : [];
                const isSent = sentIds?.length === 0 ? false : worklogIds?.every(item => sentIds?.includes(item))
                item["sent"] = isSent || false;
                item["disabled"] = findData?.loginfo === 0 ? true : item?.sent;
                item["log_hours"] = !item?.date ? "" : (findData?.loginfo || 0);
                item["bg_color"] = !item?.date ? "" : findData?.log_type_color;
                item["worklog_ids"] = !item?.date ? "" : findData?.worklog_ids;
                item["reject_remark"] = findData?.reject_remark || "";
            })
        })
        setApprovalData(obj);
    }

    const handleSelectAll = (key, e, data) => {
        let dataClone = { ...approvalData };
        dataClone?.[key]?.map((item) => {
            if (data) {
                if (item?.date === data?.date) {
                    item.sent = e.target.checked;
                }
            } else {
                item.sent = item?.disabled ? item.sent : e.target.checked || false;
            }
        })
        setApprovalData(dataClone);
    }

    const sendForApproval = async () => {
        try {
            setApprovalLoader(true);
            let ids = [];
            Object.keys(approvalData)?.forEach((item) => {
                let findData = _.filter(approvalData[item], { sent: true, disabled: false })
                const val = _.pluck(findData, "worklog_ids");
                ids = [...ids, ...val];
            })
            if (ids?.length === 0) {
                showInfo("Info", "Please select logs for approval");
                setApprovalLoader(false);
                return;
            }
            const payload = {
                "timesheet_worklog_ids": ids?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTIMESHEETAPPROVALSENT"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                if (_.isEmpty(popupLogDetails)) {
                    getTimesheetCalendarSummary();
                } else {
                    getTimesheetCalendarSummary("popup");
                }
                setApprovalLoader(false);
            }
        } catch (error) {
            console.error("error sending for approval: ", error);
            setApprovalLoader(false);
        }
    }

    const changeMonth = (delta) => {
        const newDate = new Date(popupDate.getFullYear(), popupDate.getMonth() + delta, 1);
        setPopupDate(newDate);
        getTimesheetCalendarSummary("popup", newDate);
    };

    const saveExtensions = async () => {

        if (!extensionForm?.approver) {
            showInfo("info", "Please select an approver.");
            return;
        }
        if ((!extensionForm.reason || calculateWordsFromString(extensionForm.reason) < 5)) {
            showInfo("info", "Reason should contain minimum 5 words.");
            return;
        }
        try {
            const payload = {
                enable_date_request: [{
                    enable_request_id: 0,
                    reason: extensionForm.reason,
                    apply_enable_datetime: dateConvert(extensionForm.apply_enable_datetime, "iso-string"),
                    approver1_user_code: extensionForm?.approver,
                    approve1_datetime: "",
                    approver2_user_code: 0,
                    approve2_datetime: "",
                    request_status_id: 0
                }]
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTENABLEDATEREQUEST"), payload);
            setEnabelpopup(false);
            if (res?.body?.data) {
                showSuccess('Success', res.body.message)
                setExtensionForm((prev) => ({ ...prev, reason: "", apply_enable_datetime: null, approver: null }));
            } else {
                showError('Error', res.body.message)
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
        }
    };

    return useMemo(() => ({
        tagRef, userCode, selectedEmployee, logDetails, tableData, isWorklog, setIsWorklog, dateTemplate, handleDateSelected, showTimesheet, setShowTimesheet, showAddLog, setShowAddLog, getTimesheetCalendarSummary, approvePopup, setApprovePopup, approvalData, handleSelectAll, sendForApproval, popupDate, setPopupDate, changeMonth, setPopupLogDetails, approveTimePopup, setApproveTimePopup, options, approvalLoader, loader, setLoader, logLoader, filterValue, setFilterValue, calendarDate, setCalendarDate, pendingLogDate, legendItems, legendMenuRef, legendMenuItems, logHours, callAttendanceApi, setCallAttendanceApi, enabelPopup, setEnabelpopup, extensionForm, setExtensionForm, saveExtensions
    }), [tagRef, userCode, selectedEmployee, logDetails, tableData, isWorklog, setIsWorklog, dateTemplate, handleDateSelected, showTimesheet, setShowTimesheet, showAddLog, setShowAddLog, getTimesheetCalendarSummary, approvePopup, setApprovePopup, approvalData, handleSelectAll, sendForApproval, popupDate, setPopupDate, changeMonth, setPopupLogDetails, approveTimePopup, setApproveTimePopup, options, approvalLoader, loader, setLoader, logLoader, filterValue, setFilterValue, calendarDate, setCalendarDate, pendingLogDate, legendItems, legendMenuRef, legendMenuItems, logHours, callAttendanceApi, setCallAttendanceApi, enabelPopup, setEnabelpopup, extensionForm, setExtensionForm, saveExtensions])
}

